import { withRegistry } from '@bem-react/di';
import '../polyfills/pointerfocus';
import { Radiobox as RadioboxCommon } from './Radiobox';
import { radioboxRegistry } from './Radiobox.registry/desktop';
import './Radiobox@desktop.css';
export * from './Radiobox';
export { RadioboxRadio as Radio } from './Radio/Radiobox-Radio@desktop';
export var Radiobox = withRegistry(radioboxRegistry)(RadioboxCommon);
